import React, { Component } from "react";
import { connect } from "react-redux";
import ArticleSearch from "./components/ArticleSearch";
import ArticleKeySearch from "./components/ArticleKeySearch";
import ArticleClassTab from "./components/ArticleClassTab";
import ArticleItem from "../../components/Article/ArticleItem";
import ArticleLine from "../../components/Article/ArticleLine";
import Loading from "../../components/Loading";
import ReturnTop from "../../components/ReturnTop";
import { get, post } from "../../utils/request";
import { getQueryValue, jumpUrl } from "../../utils/tool.js";
import "./style.css";
let finished = true;
class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      searchVisible: true,
      dataListVisible: true,
      topVisible: false,
      articleClassData: null,
      params: {
        title: null,
        categoryId: null,
        classId: null,
        pageNum: 1,
        pageSize: 20,
      },
    };
    this.removeListener = false;
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    var categoryId = getQueryValue("categoryId");
    var classId = getQueryValue("classId");
    var search =
      getQueryValue("search") === null ? true : getQueryValue("search");
    if (search === "false") {
      this.handleVisibleSearch();
      this.handleCloseDataList();
    }
    var title = "";
    this.requestArticleList();
    this.requestArticleClass(parseInt(categoryId, 0));
    this.handleAddScroll();
    this.handleReturnTop();
    if (categoryId === "2") {
      document.title = "浙考之家-浙考百科";
      title = "浙考之家-浙考百科";
    } else if (categoryId === "1") {
      if (classId === "2") {
        document.title = "浙考之家-强基计划";
        title = "浙考之家-强基计划";
      } else if (classId === "1") {
        document.title = "浙考之家-三位一体";
        title = "浙考之家-三位一体";
      }
    } else if (categoryId === "3") {
      document.title = "浙考之家-每日高升-高考深一度";
      title = "浙考之家-每日高升-高考深一度";
    }
    this.requestShareConfig(title);
    this.requestCategoryPay(categoryId);
  }
  /**
   * 在第一次渲染之前调用
   */
  componentWillMount() {
    this.setState({
      ...this.state,
      params: {
        title: null,
        categoryId: parseInt(getQueryValue("categoryId"), 0),
        classId: parseInt(getQueryValue("classId"), 0),
        pageNum: 1,
        pageSize: 20,
      },
    });
  }
  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.params.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
  }
  render() {
    const { searchVisible, dataListVisible, data, dataList, articleClassData } =
      this.state;
    return (
      <div ref={this.myRef}>
        <ArticleSearch
          handleCloseDataList={this.handleCloseDataList}
          handleVisibleSearch={this.handleVisibleSearch}
          visible={searchVisible}
          placeholder="请输入要搜索的内容"
        ></ArticleSearch>
        <ArticleKeySearch
          handleVisibleSearch={this.handleVisibleSearch}
          handleAddScroll={this.handleAddScroll}
          handleShowDataList={this.handleShowDataList}
          visible={!searchVisible}
          placeholder="请输入要搜索的内容"
        ></ArticleKeySearch>
        <div style={{ height: 44 }}></div>
        {articleClassData != null ? (
          <div>
            <ArticleClassTab
              visible={searchVisible}
              requestArticleList={this.requestArticleList}
              handleAddScroll={this.handleAddScroll}
              handleChangParams={this.handleChangParams.bind()}
              articleClassData={articleClassData}
            ></ArticleClassTab>
            <div style={{ height: 37 }}></div>
          </div>
        ) : (
          ""
        )}
        {data != null ? (
          <div className={dataListVisible ? "" : "display_none"}>
            {dataList.map((item, index) => {
              return (
                <div key={index}>
                  <ArticleItem
                    title={item.title}
                    hits={item.hits}
                    titleImg={item.titleImg}
                    articleType={item.articleType}
                    hashId={item.hashId}
                  ></ArticleItem>
                  <ArticleLine visible={true}></ArticleLine>
                </div>
              );
            })}
            {this.state.params.pageNum < data.data.pages ? (
              <Loading></Loading>
            ) : (
              <div className="articleList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="articleList_shim"></div>
        <ReturnTop visible={this.state.topVisible}></ReturnTop>
      </div>
    );
  }
  /**
   * 请求分享的配置
   */
  requestShareConfig = (title) => {
    const url = "https://" + document.domain + "/articlelist";
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
  /**
   * 显示列表
   */
  handleShowDataList = () => {
    this.setState({
      dataListVisible: true,
    });
  };
  /**
   * 隐藏文章的列表
   */
  handleCloseDataList = () => {
    this.setState({
      dataListVisible: false,
    });
  };
  /**
   * 控制搜索框显示和关闭
   */
  handleVisibleSearch = () => {
    this.setState({
      searchVisible: !this.state.searchVisible,
    });
  };

  /**
   * 更新文章的请求参数
   */
  handleChangParams = (classId) => {
    this.setState({
      ...this.state,
      dataList: [],
      params: {
        title: null,
        categoryId: parseInt(getQueryValue("categoryId"), 0),
        classId: classId,
        pageNum: 1,
        pageSize: 20,
      },
    });
  };

  /**
   * 获取文章标识
   */
  requestCategoryPay = (categoryId) => {
    get("/public/v1/article/category/pay/" + categoryId).then((res) => {
      if (res.data === true) {
        this.requestIsBuy();
      }
    });
  };

  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };

  /**
   * 请求文章列表
   */
  requestArticleList = () => {
    post("/public/v1/article/list", this.state.params).then((data) => {
      const newDataList = this.state.dataList.concat(data.data.list);
      this.setState({
        data: data,
        dataList: newDataList,
      });
      finished = true;
    });
  };
  /**
   * 请求文章小类
   */
  requestArticleClass = (categoryId) => {
    get("/public/v1/article/class/" + categoryId).then((res) => {
      if (res.data.length !== 0) {
        this.setState({
          articleClassData: res.data,
        });
      }
    });
  };
  /**
   * 将文章列表返回顶部
   */
  handleReturnTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const ListTop = this.myRef.current.offsetTop;
    const ListHeight = this.myRef.current.offsetHeight;
    if (finished && scrollTop >= ListHeight + ListTop - screenHeight - 2) {
      finished = false;
      setTimeout(() => {
        this.setState({
          params: {
            ...this.state.params,
            pageNum: this.state.params.pageNum + 1,
          },
        });
        this.requestArticleList();
      }, 500);
    }
    if (scrollTop >= 1200) {
      this.setState({
        topVisible: true,
      });
    } else {
      this.setState({
        topVisible: false,
      });
    }
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(ArticleList);



// WEBPACK FOOTER //
// ./src/containers/ArticleList/index.js